import { useEffect, useState } from "react";
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useDispatch, useSelector } from "react-redux";
import { updateSection } from "../../../store/Profiles/profilesSlice";

const StepHousing = ({ onBack, onNext }) => {
    const dispatch = useDispatch();
    const storedData = useSelector(state => state.profiles.housingData);
    const { t } = useTranslation();
    const [housingData, setHousingData] = useState({
        housingType: "",
        otherHousing: "",
        housingStability: "",
        physicalConditions: "",
        hasPhysicalConditions: "",
        otherPersons: "",
        householdMembers: [{ name: "", relationship: "", age: "", mayWeContact: "" }],
    });

    useEffect(() => {
        setHousingData  ((prevData) => ({
            ...prevData,
            ...storedData
        }));
    }, [storedData]);

    const handleInputChange = (field, value) => {
        setHousingData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
    };

    const addHouseholdMember = () => {
        setHousingData((prevData) => ({
            ...prevData,
            householdMembers: [...prevData.householdMembers, { name: "", relationship: "", age: "", mayWeContact: "" }],
        }));
    };

    const removeHouseholdMember = () => {
        setHousingData((prevData) => ({
            ...prevData,
            householdMembers: prevData.householdMembers.slice(0, -1),
        }));
    };

    const handleHouseholdChange = (index, field, value) => {
        const updatedMembers = housingData.householdMembers.map((member, i) => 
            i === index ? { ...member, [field]: value } : member
        );
    
        setHousingData((prevData) => ({
            ...prevData,
            householdMembers: updatedMembers,
        }));
    };

    const handleNextStep = async () => {
        await handleSaveData(); // 🔹 Espera que termine antes de seguir
        onNext();
    };

    const handleChange = (field, value) => {
        setHousingData((prevData) => ({
            ...prevData,
            [field]: value
        }));
    };

    const handleSaveData = async () => {
      dispatch(updateSection({ section: "housingData", data: { housingData:housingData } }));
    }
    return (
        <>
            <Typography variant="h6" gutterBottom>{t("Profiles.Housing.Housing")}</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 3 }}>
                <RadioGroup 
                    row
                    value={housingData.housingType}
                    onChange={(e) => handleChange("housingType", e.target.value)}
                >
                    <FormControlLabel value="African" control={<Radio />} label={t("Profiles.Housing.Apartment/Condo")} />
                    <FormControlLabel value="American/Black" control={<Radio />} label={t("Profiles.Housing.House")} />
                    <FormControlLabel value="Latino/Hispanic" control={<Radio />} label={t("Profiles.Housing.MobileHome")} />
                    <FormControlLabel value="Asian/PacificIslander" control={<Radio />} label={t("Profiles.Housing.GroupHome")} />
                    <FormControlLabel value="NativeAmerican" control={<Radio />} label={t("Profiles.Housing.Transitional")} />
                    <FormControlLabel value="Black/Haitian" control={<Radio />} label={t("Profiles.Housing.Homeless")} />
                    <FormControlLabel value="White/Non-Hispanic" control={<Radio />} label={t("Profiles.Housing.Rent")} />
                    <FormControlLabel value="Own" control={<Radio />} label={t("Profiles.Housing.Own")} />
                    <FormControlLabel value="Other" control={<Radio />} label={t("Profiles.Housing.Other")} />
                </RadioGroup>
                {housingData.housingType === "Other" && (
                    <TextField 
                        fullWidth 
                        label={t("Profiles.Housing.Explain")} 
                        margin="normal"
                        value={housingData.OtherRaceEthnicity}
                        onChange={(e) => handleChange("otherHousing", e.target.value)}
                    />
                )}
            </Box>


            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 3 }}>
                <FormLabel component="legend">{t("Profiles.Housing.Alsocheckoneofthefollowing")}</FormLabel>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <FormControl component="fieldset">
                    <RadioGroup row value={housingData.housingStability} onChange={(e) => handleInputChange("housingStability", e.target.value)}>
                        <FormControlLabel value="Permanent" control={<Radio />} label={t("Profiles.Housing.Permanent")} />
                        <FormControlLabel value="Non-Permanent" control={<Radio />} label={t("Profiles.Housing.Non-Permanent")} />
                    </RadioGroup>
                </FormControl>
            </Box>

            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-start" }}>
                <FormControl component="fieldset">
                    <FormLabel component="legend">{t("Profiles.Housing.Doestheclienthaveanyphysical")}</FormLabel>
                    <RadioGroup row value={housingData.hasPhysicalConditions} onChange={(e) => handleInputChange("hasPhysicalConditions", e.target.value)}>
                        <FormControlLabel value="yes" control={<Radio />} label={t("Profiles.Yes")} />
                        <FormControlLabel value="no" control={<Radio />} label={t("Profiles.No")} />
                    </RadioGroup>
                </FormControl>
            </Box>
            {housingData.hasPhysicalConditions === "yes" && (
                <TextField 
                    fullWidth 
                    label={t("Profiles.Housing.Ifyes,pleasedescribe")} 
                    margin="normal" value={housingData.physicalConditions} 
                    onChange={(e) => handleInputChange("physicalConditions", e.target.value)} 
                />
            )}
            

            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-start" }}>
                <FormControl component="fieldset">
                    <FormLabel component="legend">{t("Profiles.Housing.Arethereotherpersons")}</FormLabel>
                    <RadioGroup row value={housingData.otherPersons} onChange={(e) => handleInputChange("otherPersons", e.target.value)}>
                        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                        <FormControlLabel value="no" control={<Radio />} label="No" />
                    </RadioGroup>
                </FormControl>
            </Box>
            {housingData.otherPersons === "yes" && (
                <>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{t("Profiles.Housing.Name")}</TableCell>
                                <TableCell>{t("Profiles.Housing.Relationship")}</TableCell>
                                <TableCell>{t("Profiles.Housing.Age")}</TableCell>
                                <TableCell>{t("Profiles.Housing.MayWeContact?")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {housingData.householdMembers.map((member, index) => (
                                <TableRow key={index}>
                                    <TableCell><TextField fullWidth value={member.name} onChange={(e) => handleHouseholdChange(index, "name", e.target.value)} /></TableCell>
                                    <TableCell><TextField fullWidth value={member.relationship} onChange={(e) => handleHouseholdChange(index, "relationship", e.target.value)} /></TableCell>
                                    <TableCell><TextField fullWidth value={member.age} onChange={(e) => handleHouseholdChange(index, "age", e.target.value)} /></TableCell>
                                    <TableCell>
                                        <RadioGroup row value={member.mayWeContact } onChange={(e) => handleHouseholdChange(index, "mayWeContact", e.target.value)}>
                                            <FormControlLabel value="yes" control={<Radio />} label={t("Profiles.Yes")} />
                                            <FormControlLabel value="no" control={<Radio />} label={t("Profiles.No")} />
                                        </RadioGroup>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Button variant="contained" color="primary" sx={{ mt: 2, mr: 1 }} onClick={addHouseholdMember}>{t("Profiles.Housing.AddMember")}</Button>
                <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={removeHouseholdMember} disabled={housingData.householdMembers.length === 1}>{t("Profiles.Housing.RemoveLastMember")}</Button>
                </>
            )}

            {/* Botones */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Button startIcon={<ArrowBackIcon />} onClick={onBack} variant="outlined">
                    {t("common.back")}
                </Button>
                <Button endIcon={<ArrowForwardIcon />} onClick={handleNextStep} variant="contained" color="primary">
                    {t("common.next")}
                </Button>
            </Box>
        </>
    );
};

export default StepHousing;
